import { FC } from 'react';

import { DataButton } from 'components/Shared/SharedComponents';
import styles from 'components/Sections/OtherAstrologySigns/OtherAstrologySigns.module.scss';
import { OtherAstrologySignsSelect } from 'components/Sections/OtherAstrologySigns';
import { SignsOtherSignsInterface } from 'components/Sections/OtherAstrologySigns/declarations';

const OtherAstrologySigns: FC<SignsOtherSignsInterface> = ({
  title,
  zodiacSigns,
  button,
  chevron,
  selectedItem,
  signImageSize,
  isSection = false,
  redirectToSignPage,
  setSelectedItem,
}) => {
  const rootClass = isSection ? 'otherSignsSection' : 'otherSigns';
  const defaultSelectTitle = selectedItem?.title;
  const applyButton = () => {
    if (!button) {
      return null;
    }

    const { title: buttonText } = button;

    return (
      <DataButton
        link={button}
        onClick={redirectToSignPage}
        className={styles[`${rootClass}Button`]}
      >
        {buttonText}
      </DataButton>
    );
  };

  return (
    <div className={styles[rootClass]}>
      <span className={styles[`${rootClass}Title`]}>{title}</span>
      <OtherAstrologySignsSelect
        title={defaultSelectTitle!}
        options={zodiacSigns}
        chevron={chevron}
        signImageSize={signImageSize}
        previewItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
      {applyButton()}
    </div>
  );
};

export default OtherAstrologySigns;
